/*
 * Copyright (c) 2020. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <https://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MenuService } from '@app/core/menu/menu.service';
import { Shell } from '@app/shell/shell.service';
import { NotificationsListComponent } from '@app/notifications/notifications/notifications-list/notifications-list.component';
import { extract } from '@app/core';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'notifications',
      component: NotificationsListComponent,
      data: { title: extract('Notifications') },
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NotificationsRoutingModule {
  constructor(menuService: MenuService) {
    menuService.addItem({
      key: 'notifications',
      title: 'Notifications',
      icon: 'far fa-flag',
      path: '/notifications',
    });
  }
}
